import React from "react";

import ReactDOM from "react-dom";
import singleSpaReact from "single-spa-react";
import MyWorkItems from "./components/myWorkItems/MyWorkItems";
import { getEnv } from "./utils/getEnv";
import { WorkItems } from "./components/workItems/WorkItems";
import { PlatformSecure } from "@platform/core";
import { WorkGroups } from "./components/workManagementAdmin/WorkGroups";
import { WorkBuilder } from "./components/workManagementAdmin/workTemplates/WorkBuilder";

const lifecycles = singleSpaReact({
  React,
  ReactDOM,
  rootComponent: () => (
    <React.StrictMode>
      <PlatformSecure>
        <WorkBuilder />
        <MyWorkItems />
        <WorkItems />
        <WorkGroups />
      </PlatformSecure>
    </React.StrictMode>
  ),
  errorBoundary(/*err, info, props*/) {
    return <div>Error</div>;
  },
});

// noinspection JSUnusedGlobalSymbols
export const { bootstrap, mount, unmount } = lifecycles;

export const WORK_ITEMS_BFF_API_BASE = `${
  getEnv().API_BASE_URL
}/st/platform/workitems/services/v1/workitems`;

export const WORK_MANAGEMENT_ADMIN_BFF_API_BASE = `${
  getEnv().API_BASE_URL
}/st/platform/workitems/services/v1`;

export const WORK_MANAGEMENT_ADMIN_BFF_API_BASE_V2 = `${
  getEnv().API_BASE_URL
}/st/platform/workitems/services/v2`;

export const WORKITEM_BFF_API_BASE_USERS = `${
  getEnv().API_BASE_URL
}/st/platform/workitems/services/v1/users`;

export { MyWorkItemDetails } from "./components/myWorkItems/MyWorkItemDetails";
export { ShowWorkItemHistory } from "./components/workItems/ShowWorkItemHistory";
export { MyWorkItemsButton } from "./components/myWorkItems/MyWorkItemsButton";
export { WorkItemsButton } from "./components/workItems/WorkItemsButton";
export { WorkGroupsButton } from "./components/workManagementAdmin/WorkGroupsButton";
export { WorkBuilderButton } from "./components/workManagementAdmin/workTemplates/WorkBuilderButton";
